import {PlaceholderComponent} from '../shared/placeholder.component';
import {WarrantyFormComponent} from './warranty-form.component';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [];

['survey', 'execution', 'maintenance'].forEach((assignmentType: string) => {
  CHILD_STATES.push(...[{
      name: `assignment.${assignmentType}.edit.warranty`,
      abstract: true,
      component: PlaceholderComponent,
      future: true,
      data: {
        pageTitle: 'states.warranty.pageTitle',
        scopes: ['warranty:read']
      }
    },
    {
      name: `assignment.${assignmentType}.edit.warranty.add`,
      component: WarrantyFormComponent,
      future: true,
      data: {
        pageTitle: 'states.warranty.add.pageTitle',
        scopes: ['warranty:create']
      }
    },
    {
      name: `assignment.${assignmentType}.edit.warranty.edit`,
      component: WarrantyFormComponent,
      future: true,
      data: {
        pageTitle: 'states.warranty.edit.pageTitle',
        scopes: ['warranty:update']
      }
    }
  ]);
});

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})
export class WarrantyRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/warranty/warranty.routes.ts